import { GetterTree } from 'vuex'
import { MessageCategoriesState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<MessageCategoriesState, RootState> = {
    messageCategories:state => state.messageCategories,
    allowedTransports:state => state.allowedTransports,
    regexRulesItem:state => state.regexRulesItem,
};
